<template>
  <div class="w-full">
    <ValidationObserver
        ref="observer"
        class="transition duration-500 ease-in-out transform w-full"
        style="transition: all 1s !important"
        tag="form"
        @submit.prevent="submit()"
    >
      <!-- <v-card>
       <v-card-text>
        
        </v-card-text>
        </v-card> -->
      <div class="w-full flex py-5 px-5">
        <v-card class="mx-auto w-full assign-course-card" flat max-height="auto" max-width="1000">
          <v-card-text v-if="formValues.editMode == false" class="trainee-summary">
            <p class="trainee-summary__title">Trainee Information</p>
            <div class="trainee-summary-grid">
              <div class="trainee-summary-item">
                <p class="trainee-summary-item__label">Full Name</p>
                <p class="trainee-summary-item__value">
                  {{ displayFullName }}
                </p>
              </div>
              <div class="trainee-summary-item">
                <p class="trainee-summary-item__label">Gender</p>
                <p class="trainee-summary-item__value">
                  {{ normalizeDisplayValue(displayTrainee.gender) || "-" }}
                </p>
              </div>
              <div class="trainee-summary-item">
                <p class="trainee-summary-item__label">Birth Date</p>
                <p class="trainee-summary-item__value">
                  {{ normalizeDisplayValue(displayTrainee.birthdate) || "-" }}
                </p>
              </div>
              <div class="trainee-summary-item">
                <p class="trainee-summary-item__label">TIN Number</p>
                <p class="trainee-summary-item__value">
                  {{ normalizeDisplayValue(displayTrainee.tin) || "-" }}
                </p>
              </div>
              <div class="trainee-summary-item">
                <p class="trainee-summary-item__label">License Number</p>
                <p class="trainee-summary-item__value">
                  {{ normalizeDisplayValue(displayTrainee.licenseNumber) || "-" }}
                </p>
              </div>
              <div class="trainee-summary-item">
                <p class="trainee-summary-item__label">Phone Number</p>
                <p class="trainee-summary-item__value">
                  {{ displayPhoneNumber }}
                </p>
              </div>
              <div class="trainee-summary-item">
                <p class="trainee-summary-item__label">Employee ID</p>
                <p class="trainee-summary-item__value">
                  {{ normalizeDisplayValue(displayTrainee.employeeId) || "-" }}
                </p>
              </div>
              <div class="trainee-summary-item">
                <p class="trainee-summary-item__label">Unemployed</p>
                <p class="trainee-summary-item__value">
                  {{ displayUnemployed }}
                </p>
              </div>
              <div class="trainee-summary-item">
                <p class="trainee-summary-item__label">Facility</p>
                <p class="trainee-summary-item__value">
                  {{ displayFacility }}
                </p>
              </div>
              <div class="trainee-summary-item">
                <p class="trainee-summary-item__label">Email</p>
                <p class="trainee-summary-item__value">
                  {{ displayEmail }}
                </p>
              </div>
              <div class="trainee-summary-item">
                <p class="trainee-summary-item__label">Health Profession</p>
                <p class="trainee-summary-item__value">
                  {{ displayHealthProfession }}
                </p>
              </div>
              <div class="trainee-summary-item">
                <p class="trainee-summary-item__label">Region</p>
                <p class="trainee-summary-item__value">
                  {{ displayRegion }}
                </p>
              </div>
              <div class="trainee-summary-item">
                <p class="trainee-summary-item__label">Zone</p>
                <p class="trainee-summary-item__value">
                  {{ displayZone }}
                </p>
              </div>
              <div class="trainee-summary-item">
                <p class="trainee-summary-item__label">Woreda</p>
                <p class="trainee-summary-item__value">
                  {{ displayWoreda }}
                </p>
              </div>
              <div class="trainee-summary-item">
                <p class="trainee-summary-item__label">Kebele</p>
                <p class="trainee-summary-item__value">
                  {{ normalizeDisplayValue(displayTrainee.kebele) || "-" }}
                </p>
              </div>
            </div>
          </v-card-text>
          <v-divider></v-divider>
          <div class="flex flex-wrap my-6 mx-6 mb-6">
            <div
                v-if="formValues.editMode == true"
                class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required"
            >
              <label
                  class="
                  block
                  uppercase
                  tracking-wide
                  text-gray-700 text-xs
                  font-bold
                  mb-2
                "
              >First Name</label
              >
              <validation-provider v-slot="{ errors }" rules="required">
                <input
                    id="firstName"
                    v-model="formValues.person.firstname"
                    class="
                    shadow
                    appearance-none
                    border
                    rounded
                    w-full
                    py-2
                    px-3
                    text-gray-700
                    leading-tight
                    focus:outline-none focus:shadow-outline
                  "
                    name
                    type="text"
                />
                <span class="text-gray-600 text-xs italic text-red-700">{{
                    errors[0]
                  }}</span>
              </validation-provider>
            </div>
            <div
                v-if="formValues.editMode == true"
                class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required"
            >
              <label
                  class="
                  block
                  uppercase
                  tracking-wide
                  text-gray-700 text-xs
                  font-bold
                  mb-2
                "
              >Father Name</label
              >
              <validation-provider v-slot="{ errors }" rules="required">
                <input
                    id="middleName"
                    v-model="formValues.person.middlename"
                    class="
                    shadow
                    appearance-none
                    border
                    rounded
                    w-full
                    py-2
                    px-3
                    text-gray-700
                    leading-tight
                    focus:outline-none focus:shadow-outline
                  "
                    name
                    type="text"
                />
                <span class="text-gray-600 text-xs italic text-red-700">{{
                    errors[0]
                  }}</span>
              </validation-provider>
            </div>
            <div
                v-if="formValues.editMode == true"
                class="w-full md:w-1/2 px-3 mb-0 md:mb-0 required"
            >
              <label
                  class="
                  block
                  uppercase
                  tracking-wide
                  text-gray-700 text-xs
                  font-bold
                  mb-2
                "
              >Grandfather Name</label
              >
              <validation-provider v-slot="{ errors }" rules="required">
                <input
                    id="lastName"
                    v-model="formValues.person.lastname"
                    class="
                    shadow
                    appearance-none
                    border
                    rounded
                    w-full
                    py-2
                    px-3
                    text-gray-700
                    leading-tight
                    focus:outline-none focus:shadow-outline
                  "
                    name
                    type="text"
                />
                <span class="text-gray-600 text-xs italic text-red-700">{{
                    errors[0]
                  }}</span>
              </validation-provider>
            </div>
            <div
                v-if="formValues.editMode == true"
                class="w-full md:w-1/2 px-3 mb-0 md:mb-0 required"
            >
              <label
                  class="
                  block
                  uppercase
                  tracking-wide
                  text-gray-700 text-xs
                  font-bold
                  mb-2
                "
              >Gender</label
              >
              <validation-provider v-slot="{ errors }" rules="required">
                <input
                    id="Male"
                    v-model="formValues.person.gender"
                    class="my-3 ml-5"
                    type="radio"
                    value="male"
                />
                <label for="Male"> Male </label>
                <br/>

                <input
                    id="Female"
                    v-model="formValues.person.gender"
                    class="my-3 ml-5"
                    type="radio"
                    value="female"
                />
                <label for="Female"> Female </label>
                <br/>
                <span class="text-gray-600 text-xs italic text-red-700">{{
                    errors[0]
                  }}</span>
              </validation-provider>
              <br/>
            </div>
            <div class="w-full md:w-1/2 px-3 mb-6 required">
              <label
                  class="
                  block
                  uppercase
                  tracking-wide
                  text-gray-700 text-xs
                  font-bold
                  mb-2
                "
              >Trainee Location</label
              >
              <validation-provider v-slot="{ errors }" rules="required">
                <v-select
                    v-model="formValues.locationId"
                    :elevation="1"
                    :items="REGIONS"
                    :loading="locationLoading"
                    dense
                    hint="Select location"
                    item-text="name"
                    item-value="id"
                    solo
                >
                </v-select>

                <span class="text-gray-600 text-xs italic text-red-700">{{
                    errors[0]
                  }}</span>
              </validation-provider>
              <br/>
            </div>
            <div class="w-full md:w-1/2 px-3 mb-6 required">
              <label
                  class="
                  block
                  uppercase
                  tracking-wide
                  text-gray-700 text-xs
                  font-bold
                  mb-2
                "
              >CPD Activity</label
              >
              <validation-provider v-slot="{ errors }" rules="required">
                <v-select
                    v-model="selectedCategory"
                    :clearable="true"
                    :elevation="1"
                    :items="CATEGORIES"
                    :loading="cpdActLoading"
                    dense
                    hint="Select cpd activity"
                    item-text="name"
                    item-value="id"
                    solo
                    @change="categoryChanged($event)"
                >
                </v-select>

                <span class="text-gray-600 text-xs italic text-red-700">{{
                    errors[0]
                  }}</span>
              </validation-provider>
              <br/>
            </div>
            <div v-if="COURSES.length !== 0" class="w-full md:w-1/2 px-3 mb-6">
              <label
                  class="
                  block
                  uppercase
                  tracking-wide
                  text-gray-700 text-xs
                  font-bold
                  mb-2
                "
              >Course(Category 1)</label
              >
              <!-- <validation-provider v-slot="{ errors }"> -->
              <v-autocomplete
                  v-model="formValues.course"
                  :clearable="true"
                  :items="COURSES"
                  :loading="courseLoading"
                  :searchable="true"
                  class="
                  shadow
                  appearance-none
                  border
                  rounded
                  w-full
                  py-2
                  px-3
                  text-gray-700
                  leading-tight
                  focus:outline-none focus:shadow-outline
                "
                  hint="Select course"
                  item-text="course.courseName"
                  persistent-hint
                  return-object
              >
              </v-autocomplete>

              <!-- <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span> -->
              <!-- </validation-provider> -->
              <br/>
            </div>
            <div
                v-else-if="CATEGORY2_COURSES.length !== 0"
                class="w-full md:w-1/2 px-3 mb-6"
            >
              <label
                  class="
                  block
                  uppercase
                  tracking-wide
                  text-gray-700 text-xs
                  font-bold
                  mb-2
                "
              >Course(Category 2)</label
              >
              <v-autocomplete
                  v-model="formValues.category2Course"
                  :clearable="true"
                  :items="CATEGORY2_COURSES"
                  :loading="courseLoading"
                  :searchable="true"
                  class="
                  shadow
                  appearance-none
                  border
                  rounded
                  w-full
                  py-2
                  px-3
                  text-gray-700
                  leading-tight
                  focus:outline-none focus:shadow-outline
                "
                  hint="Select course"
                  item-text="courseTitleCat2"
                  item-value="id"
                  persistent-hint
              >
              </v-autocomplete>
            </div>
            <div v-else class="pl-4">
              <p class="grey--text">
                <v-icon class="mr-1" left>mdi-information-variant</v-icon>
                No courses to display until cpd activity selected.
              </p>
            </div>
            <div class="w-full md:w-1/2 px-3 mb-6"></div>
            <div class="w-full assign-course-actions px-3">
              <v-btn
                  class="assign-course-btn white--text"
                  color="primary"
                  depressed
                  type="button"
                  @click="submit()"
              >
                <v-icon left small>mdi-check-circle</v-icon>
                  {{ formValues.editMode ? "Update Course" : "Assign Course" }}
              </v-btn>
            </div>
          </div>
        </v-card>
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
import {extend, ValidationObserver, ValidationProvider} from "vee-validate";
import {required} from "vee-validate/dist/rules";
import {getCategories, getProgramsLite, getRegionList} from "@/utils/helper";

extend("required", {
  ...required,
  message: "This field is required",
});

export default {
  props: {
    trainee: Object,
  },
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      values: {
        id: "",
        courseid: "",
        creditHours: "",
        trainingProvider: "",
        person: {
          firstname: "",
          lastname: "",
          gender: "",
          birthdate: "",
          tin: "",
          licenseNumber: "",
          contacts: {
            mobilephone: "",
          },
          employee_job_history: {
            jobtitlename: "",
            joineddate: "",
          },
          editMode: false,
        },
        startDate: "",
        endDate: "",
      },
      formValues: {
        locationId: null,
        personguid: "",
        cpdActivityId: null,
        course: null,
        editMode: false,
        category2Course: null,
        person: {
          firstname: null,
          middlename: null,
          lastname: null,
          gender: null,
          practitionerId: null,
          licenseNumber: null,
          tin: null
        },
      },
      COURSES: [],
      PROGRAMS: [],
      REGIONS: [],
      showProgress: false,
      categoryCourse2: null,
      oldTraineeProgram: null,
      clearable: null,
      locationLoading: false,
      courseLoading: false,
      searchable: null,
      cpdActLoading: false,
      CPD_ACTIVITIES: [],
      cpdActivityChangeCount: 0,
      CATEGORIES: [],
      selectedCategory: null,
      CATEGORY2_COURSES: [],
    };
  },
  computed: {
    displayTrainee() {
      const person = this.formValues?.person || {};
      return {
        ...person,
        ...this.formValues,
      };
    },
    displayFullName() {
      const explicitFullName = this.normalizeDisplayValue(this.displayTrainee?.fullName);
      const firstName = this.normalizeDisplayValue(this.displayTrainee?.firstname || this.displayTrainee?.firstName);
      const middleName = this.normalizeDisplayValue(this.displayTrainee?.middlename || this.displayTrainee?.middleName);
      const lastName = this.normalizeDisplayValue(this.displayTrainee?.lastname || this.displayTrainee?.lastName);
      const prefix = this.normalizeDisplayValue(this.displayTrainee?.prefix);
      const name = [firstName, middleName, lastName].filter(Boolean).join(" ");
      const resolvedName = explicitFullName || name;
      return `${prefix ? `${prefix} ` : ""}${resolvedName}`.trim() || "-";
    },
    displayContact() {
      const contacts = this.formValues?.contacts || this.formValues?.person?.contacts || [];
      return Array.isArray(contacts) && contacts.length ? contacts[0] : null;
    },
    displayPhoneNumber() {
      return this.normalizeDisplayValue(this.displayTrainee?.phoneNumber) ||
          this.normalizeDisplayValue(this.displayContact?.mobilephone) ||
          "-";
    },
    displayEmail() {
      return this.normalizeDisplayValue(this.displayTrainee?.facilityEmail) ||
          this.normalizeDisplayValue(this.displayTrainee?.email) ||
          this.normalizeDisplayValue(this.displayContact?.email) ||
          "-";
    },
    displayFacility() {
      return this.normalizeDisplayValue(this.displayTrainee?.facility?.name) || "-";
    },
    displayHealthProfession() {
      return this.normalizeDisplayValue(this.displayTrainee?.healthProfession?.name) || "-";
    },
    displayRegion() {
      return this.normalizeDisplayValue(this.displayTrainee?.woreda?.zone?.location?.name) || "-";
    },
    displayZone() {
      return this.normalizeDisplayValue(this.displayTrainee?.woreda?.zone?.name) || "-";
    },
    displayWoreda() {
      return this.normalizeDisplayValue(this.displayTrainee?.woreda?.name) || "-";
    },
    displayUnemployed() {
      if (this.displayTrainee?.unemployed === true) return "Yes";
      if (this.displayTrainee?.unemployed === false) return "No";
      return "-";
    },
  },
  async created() {
    await this.initLookups();
    if (this.trainee != null) {
      this.formValues = this.trainee;

      this.trainee.person
          ? (this.formValues.editMode = true)
          : (this.formValues.editMode = false);

      if (this.formValues.editMode == true) {

        if (this.formValues.trainee_cat2_course) {
          const categoryId = this.formValues.trainee_cat2_course.program
              .categoryId;
          this.selectedCategory = categoryId;

        } else if (this.formValues.trainee_course) {
          const categoryId = this.formValues.trainee_course.program.categoryId;
          this.selectedCategory = categoryId;

        }
        this.categoryChanged(this.selectedCategory);
      }
    }
  },
  methods: {
    normalizeDisplayValue(value) {
      if (value === null || value === undefined) return "";
      if (typeof value === "string") return value.trim();
      if (typeof value === "number") return String(value);
      if (typeof value === "boolean") return value ? "Yes" : "No";
      if (Array.isArray(value)) {
        const merged = value
            .map((item) => this.normalizeDisplayValue(item))
            .filter(Boolean)
            .join(" ");
        return merged.trim();
      }
      if (typeof value === "object") {
        const candidate =
            this.normalizeDisplayValue(value.fullName) ||
            this.normalizeDisplayValue(value.name) ||
            this.normalizeDisplayValue(value.value) ||
            this.normalizeDisplayValue(value.label);
        return candidate || "";
      }
      return "";
    },
    async initLookups() {
      this.locationLoading = true;
      this.cpdActLoading = true;
      this.REGIONS = await getRegionList();
      this.locationLoading = false;
      this.CATEGORIES = await getCategories();
      const cpdActRes = await getProgramsLite();
      this.CPD_ACTIVITIES = cpdActRes.data ? cpdActRes.data.rows : null;
      this.cpdActLoading = false;
    },
    categoryChanged(event) {
      this.courseLoading = true;
      const courses = [];
      const category2Courses = [];
      this.formValues.course = null;
      this.formValues.category2Course = null;

      this.CPD_ACTIVITIES.forEach((program) => {
        if (event == program.categoryId) {
          if (program.category.categoryType == "CAT1") {
            const programCourses = program.program_courses;
            for (let index = 0; index < programCourses.length; index++) {
              const element = programCourses[index];
              courses.push(element);
            }
          } else {
            category2Courses.push(program);
          }
        }
      });

      this.COURSES = courses ? courses : null;
      this.CATEGORY2_COURSES = category2Courses ? category2Courses : null;
      if (
          this.formValues.editMode == true &&
          this.cpdActivityChangeCount == 0
      ) {
        if (this.formValues.trainee_cat2_course) {
          this.formValues.category2Course = this.formValues.trainee_cat2_course.programId;
          this.formValues.course = null;
        } else {
          this.formValues.course = this.formValues.trainee_course;
          this.formValues.category2Course = null;
        }
      }
      this.courseLoading = false;
      this.cpdActivityChangeCount += 1;
    },
    async submit() {
      delete this.formValues.courseIds;
      this.formValues.editMode == false ? delete this.formValues.id : null;
      if (!(await this.$refs.observer.validate())) return;
      this.$refs.observer.validate();
      this.$emit("registerOrUpdateTrainee", this.formValues);
      this.$emit("close");
    },
  },
  watch: {},
};
</script>
<style scoped>
.contact-wrapper:nth-child(2) {
  padding-left: 0px !important;
}

.assign-course-card {
  border: 1px solid rgba(15, 23, 42, 0.08);
  border-radius: 12px;
  background: #ffffff;
}

.trainee-summary {
  background: #f8fafc;
  border-bottom: 1px solid rgba(15, 23, 42, 0.08);
}

.trainee-summary__title {
  margin-bottom: 12px;
  color: #1f2937;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
}

.trainee-summary-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 12px;
}

.trainee-summary-item {
  border: 1px solid rgba(15, 23, 42, 0.08);
  border-radius: 10px;
  background: #ffffff;
  padding: 10px 12px;
}

.trainee-summary-item__label {
  margin-bottom: 4px;
  color: #64748b;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
}

.trainee-summary-item__value {
  margin: 0;
  color: #0f172a;
  font-size: 14px;
  font-weight: 600;
}

.assign-course-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 4px;
}

.assign-course-btn {
  text-transform: none;
  font-weight: 600;
  letter-spacing: 0;
  min-width: 160px;
}

.required > label::after {
  content: "*";
  color: red;
  padding-left: 3px;
}
</style>
